<!--
 * @Author: hongqi
 * @LastEditors: hongqi
 * @Date: 2021-01-05 13:48:41
 * @LastEditTime: 2021-01-07 18:07:54
-->
<template>
    <div ref="container">
        <div class="collectionGoods" v-if="collectProductList.length > 0">
            <div class="item acea-row row-between-wrapper" v-for="(item, index) in collectProductList" :key="index">
                <div class="border1" v-if="!item.select" @click.stop="itemSelect(index)"></div>
                <img src="../../assets/images/icon_select_ed.png" v-else class="icon-select-ed" alt="" @click.stop="itemSelect(index)">
                <router-link :to="{ path: '/detail/' + item.pid+'?shop_type='+item.shop_type }" class="pictrue"><img :src="item.image" /></router-link>
                <router-link :to="{ path: '/detail/' + item.pid+'?shop_type='+item.shop_type }" class="text acea-row row-column-between">
                    <div class="infor line1">{{ item.store_name }}</div>
                    <div class="infor intro">{{item.store_info}}</div>
                    <div class="acea-row row-between-wrapper">
                        <div class="money font-color-red"><span style="font-size:.24rem">￥</span>{{ item.price }}</div>
                    </div>
                </router-link>
            </div>
        </div>
        <Loading :loaded="loadend" :loading="loading"></Loading>
        <div class="noCommodity" style="background-color:#fff;" v-if="collectProductList.length < 1 && page > 1">
            <div class="noPictrue">
                <img src="@assets/images/noCollection.png" class="image" />
            </div>
            <Recommend></Recommend>
        </div>
        <div style="height:1.2rem"></div>
        <div class="collectBottomFixed">
            <div class="collectBottonFlex" @click="allSelect">
                <div class="border1" v-if="!selectStatus"></div>
                <img src="../../assets/images/icon_select_ed.png" v-else class="icon-select-ed" alt="">
                <div class="allChoose">全选</div>
            </div>
            <div class="collectBottonFlex red" @click="delCollection">
                <div>删除</div>
            </div>
        </div>
    </div>
</template>
<script>
import Recommend from "@components/Recommend";
import { getCollectUser, postCollectAllDel } from "@api/user";
import Loading from "@components/Loading";
export default {
    name: "GoodsCollection",
    components: {
        Recommend,
        Loading,
    },
    props: {},
    data: function () {
        return {
            page: 1,
            limit: 20,
            collectProductList: [],
            loadTitle: "",
            selectStatus: false,
            loading: false,
            loadend: false,
        };
    },
    mounted: function () {
        this.get_user_collect_product();
        this.$scroll(this.$refs.container, () => {
            !this.loading && this.get_user_collect_product();
        });
    },
    methods: {
        allSelect() {
            let selectStatus = this.selectStatus;
            selectStatus = !selectStatus;
            
            let collectProductList = this.collectProductList;
            if(!collectProductList.length){
              return
            }
            for (let i = 0; i < collectProductList.length; i++) {
                if (selectStatus) {
                    collectProductList[i].select = true;
                } else {
                    collectProductList[i].select = false;
                }
            }
            this.selectStatus = selectStatus;
            this.collectProductList = collectProductList;
        },
        checkSelect() {
            let selectStatus = this.selectStatus;
            let collectProductList = this.collectProductList;
            let num = 0;
            collectProductList.map((item, index) => {
                if (item.select) {
                    num++;
                } else {
                    num--;
                }
            });
            if(num == collectProductList.length){
              selectStatus = true;
            }else{
              selectStatus = false;
            }
            this.selectStatus = selectStatus;
        },
        itemSelect(index) {
            let collectProductList = this.collectProductList;
            collectProductList[index].select = !collectProductList[index]
                .select;
             
            this.$set(
                collectProductList[index],
                "select",
                collectProductList[index].select
            );
            this.$forceUpdate();
            this.checkSelect();
        },
        get_user_collect_product: function () {
            let that = this;
            if (that.loading) return; //阻止下次请求（false可以进行请求）；
            if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
            that.loading = true;
            getCollectUser(that.page, that.limit).then((res) => {
                that.loading = false;
                //apply();js将一个数组插入另一个数组;
                that.collectProductList.push.apply(
                    that.collectProductList,
                    res.data
                );
                that.collectProductList.map((item, index) => {
                    item.select = false;
                });
                that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
                that.page = that.page + 1;
            });
        },
        //删除收藏；
        delCollection: function () {
            let that = this;
            let indexArr =[];
            let pidArr = [];
            let collectProductList = that.collectProductList;
            for(let i = 0;i<collectProductList.length;i++){
              if(collectProductList[i].select){
                indexArr.push(i)
                pidArr.push(collectProductList[i].pid)
              }
            }
            if(!indexArr.length){
              that.$dialog.toast({
                mes: "请选择要删除的收藏商品!",
              })
              return
            }
            console.log(indexArr,pidArr)
            let id = pidArr.join(',')
            postCollectAllDel(id).then(function () {
                that.$dialog.toast({
                    mes: "删除收藏成功!",
                    callback: () => {
                        that.loading = false;
                        that.loadend = false;
                        that.selectStatus = false;
                        that.collectProductList = [];
                        that.page = 1;
                        that.get_user_collect_product()
                    },
                });
            });
        },
    },
};
</script>
<style scoped>
.collectionGoods {
    padding: 0.4rem 0.2rem;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0);
}
.collectionGoods .item {
    margin-left: 0;
    background: #fff;
    padding-right: 0;
    border-bottom: 0;
    margin-bottom: 0.2rem;
    height: 2.08rem;
}
.collectionGoods .item .text {
    flex: 1;
    margin-left: 0.36rem;
    flex-wrap: nowrap;
    height: auto;
}
.collectionGoods .item .pictrue img {
    object-fit: contain;
}
.collectionGoods .item .text .intro {
    color: #999999;
    font-size: 0.26rem;
    margin: 0.1rem 0 0.2rem;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
.collectionGoods .item .pictrue {
    width: 1.6rem;
    height: 1.6rem;
}
.collectionGoods .item .text .money {
    font-size: 0.36rem;
    color: #333333 !important;
    font-weight: 500;
}
.icon-select-ed {
    width: 0.26rem;
    height: 0.26rem;
    object-fit: contain;
    margin-left: 0.24rem;
    margin-right: 0.16rem;
}
.border1 {
    width: 0.26rem;
    height: 0.26rem;
    border: 0.02rem solid #999999;
    border-radius: 100%;
    margin-left: 0.24rem;
    margin-right: 0.16rem;
}
.collectBottomFixed {
    width: 100%;
    height: 1rem;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 0.04rem 0.12rem 0px rgba(179, 179, 179, 0.5);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
}
.collectBottomFixed .collectBottonFlex {
    flex: 1;
    height: 1rem;
    display: flex;
    align-items: center;
    padding: 0 0.1rem;
    box-sizing: border-box;
}
.collectBottomFixed .collectBottonFlex .allChoose {
    font-size: 0.26rem;
    color: #333333;
}
.collectBottomFixed .collectBottonFlex.red {
    background: #d01112;
    justify-content: center;
    color: #ffffff;
    font-size: 0.3rem;
    padding: 0;
}
</style>